"use client"

import type { RefObject, SetStateAction } from "react"

import type { ChatbotConversationMessageCitation } from "@/generated/course-material-api/types.generated"
import { assertNotNullOrUndefined } from "@/shared-module/common/utils/nullability"

import CitationPopover from "./CitationPopover"

interface CitationPopoversProps {
  citations: ChatbotConversationMessageCitation[]
  citationNumberingMap: Map<number, number>
  triggerElement: RefObject<HTMLButtonElement | null>
  triggerElementId: string
  setTriggerElementId: (value: SetStateAction<string>) => void
  citationButtonClicked: boolean
  setCitationButtonClicked: (value: SetStateAction<boolean>) => void
  isCitationHovered: boolean
}

const CitationPopovers: React.FC<CitationPopoversProps> = (props) => {
  const { citations, citationNumberingMap } = props
  return (
    <>
      {citations.map((citation, idx) => {
        const citationNumber = assertNotNullOrUndefined(
          citationNumberingMap.get(citation.citation_number),
        )
        return (
          <CitationPopover
            key={idx}
            citation={citation}
            citationNumber={citationNumber}
            {...props}
          />
        )
      })}
    </>
  )
}

export default CitationPopovers
